import isMobileJS from 'ismobilejs';
import { isBrowserSafari } from './utils';

/**
 * List of all IMA SDK event values, along with their corresponding constants
 */
export const imaEvents = [
  'adBreakReady', // google.ima.AdEvent.Type.AD_BREAK_READY
  'adCanPlay', // google.ima.AdEvent.Type.AD_CAN_PLAY
  'adMetadata', // google.ima.AdEvent.Type.AD_METADATA
  'allAdsCompleted', // google.ima.AdEvent.Type.ALL_ADS_COMPLETED
  'click', // google.ima.AdEvent.Type.CLICK
  'complete', // google.ima.AdEvent.Type.COMPLETE
  'contentPauseRequested', // google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED
  'contentResumeRequested', // google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED
  'durationChange', // google.ima.AdEvent.Type.DURATION_CHANGE
  'expandedChanged', // google.ima.AdEvent.Type.EXPANDED_CHANGED
  'firstquartile', // google.ima.AdEvent.Type.FIRST_QUARTILE
  'impression', // google.ima.AdEvent.Type.IMPRESSION
  'interaction', // google.ima.AdEvent.Type.INTERACTION
  'linearChanged', // google.ima.AdEvent.Type.LINEAR_CHANGED
  'loaded', // google.ima.AdEvent.Type.LOADED
  'log', // google.ima.AdEvent.Type.LOG
  'midpoint', // google.ima.AdEvent.Type.MIDPOINT
  'pause', // google.ima.AdEvent.Type.PAUSED
  'resume', // google.ima.AdEvent.Type.RESUMED
  'skippableStateChanged', // google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED
  'skip', // google.ima.AdEvent.Type.SKIPPED
  'start', // google.ima.AdEvent.Type.STARTED
  'thirdquartile', // google.ima.AdEvent.Type.THIRD_QUARTILE
  'userClose', // google.ima.AdEvent.Type.USER_CLOSE
  'viewable_impression', // google.ima.AdEvent.Type.VIEWABLE_IMPRESSION
  'volumeChange', // google.ima.AdEvent.Type.VOLUME_CHANGED
  'mute', // google.ima.AdEvent.Type.VOLUME_MUTED
  'adError', // google.ima.AdErrorEvent.Type.AD_ERROR
];

/**
 * IMA Ads Manager Loaded Callback.
 *
 * Registers event listeners that will turn IMA events into player events.
 */
export function adsManagerLoadedCallback(player) {
  imaEvents.forEach(imaEvent => {
    player.ima.addEventListener(imaEvent, event => {
      player.trigger(`ads-ima-${event.type}`, event);
    });
  });
}

/**
 * Returns the ad start event to listen on
 */
export function getAdStartEvent(navigator) {
  // eslint-disable-line class-methods-use-this
  if (isMobileJS.any) {
    return 'touchend';
  }

  if (isBrowserSafari(navigator)) {
    return 'click';
  }

  return 'loadeddata';
}



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/ads.js